// extracted by mini-css-extract-plugin
export default {"container":"B23XxbBt7YV3jaippKw_","body":"OIp06oi2DZ6n5yQ7QRzC","footer":"F4Bjpf2Qt7wTCykWyYdt"};